import { PlatformThemeId } from '@reward-platform/shared-schemas'
import { getPublicAssetSrc } from './publicAssets'

export const getLogoUrlForTheme = (theme: PlatformThemeId, shouldUseMobileLogo?: boolean) => {
  const partnerName = theme.toLocaleLowerCase().replace('_', '-')
  const filenameSuffix = shouldUseMobileLogo ? 'logo-mobile' : 'logo'
  const filePath = `/assets/${partnerName}-${filenameSuffix}.svg`
  return getPublicAssetSrc(filePath)
}

export const getFaviconUrlForTheme = (theme: PlatformThemeId) =>
  getPublicAssetSrc(`/assets/favicon/${theme.toUpperCase()}.ico`)

export const getFallbackImageUrlForTheme = (theme: PlatformThemeId) =>
  getPublicAssetSrc(`/assets/default-brand-images/${theme.toLowerCase()}.svg`)

export const getStylesheetForTheme = (theme: PlatformThemeId) =>
  getPublicAssetSrc(`/assets/themes/${theme}.css`)
